module.exports = __webpack_public_path__ + "img/nrl.160e5946.png";